require(['jquery'], function ($) {
  if (window.location.hash.substr(1).split('=').length > 1) {
    lancerRechercheConseiller();
  } else {
    $('.resultat-recherche-conseiller').hide();
    $('.avec-resultats').hide();
  }
  $(window).on('hashchange', function (e) {
    lancerRechercheConseiller();
  });
  function lancerRechercheConseiller() {
    var val = window.location.hash.substr(1).split('=')[1];
    $('.param-recherche').text(val);
    $.ajax({
      url: window.location.origin + '/IA_API/ConseillersIasecuritiesController/ObtenirNombreConseillers',
      type: 'Get',
      dataType: 'json',
      data: {
        nom: val
      },
      success: function success(data) {
        var boutonTrouverConseiller = $('.bloc-contenu-trouver-conseiller a');
        var url = boutonTrouverConseiller.attr('href');
        if (data && data.nbConseillers > 0) {
          var nbResultats = data.nbConseillers;
          $('.resultat-recherche-conseiller').show();
          $('.terme-resultat').text(nbResultats > 1 ? 's' : '');
          $('.nb-resultats').text(nbResultats);
          $('.avec-resultats').show();
          $('.sans-resultats').hide();
          boutonTrouverConseiller.attr('href', url.split('?')[0] + '?q=' + val + '#by-name');
        } else {
          $('.resultat-recherche-conseiller').hide();
          boutonTrouverConseiller.attr('href', url.split('?')[0]);
          $('.avec-resultats').hide();
          $('.sans-resultats').show();
        }
      },
      // eslint-disable-next-line no-unused-vars
      error: function error(XMLHttpRequest, textStatus, errorThrown) {
        var url = $('.bloc-contenu-trouver-conseiller a').attr('href');
        $('.avec-resultats').hide();
        $('.sans-resultats').show();
        $('.resultat-recherche-conseiller').hide();
        $('.bloc-contenu-trouver-conseiller a').attr('href', url.split('?')[0]);
      }
    });
  }
});